import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63866cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "登録", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "再集計", -1))
const _hoisted_5 = {
  class: "col-auto text-center mt-2 mb-1",
  style: {"font-size":"40px"}
}
const _hoisted_6 = {
  id: "corporation-table",
  class: "table table-borderless text-end w-auto ml-auto"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"35%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"65%"} })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医療法人整理番号", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "法人番号", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "病床・外来管理番号", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医療機関コード", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  id: "facility-table",
  class: "table table-borderless ml-auto"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"14%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"20%"} }),
  /*#__PURE__*/_createElementVNode("col"),
  /*#__PURE__*/_createElementVNode("col")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-start" }, "法人名", -1))
const _hoisted_21 = { colspan: "3" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = {
  class: "text-start",
  colspan: "2"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "役員数（人）", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "職員数（人）", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "都道府県", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "市区町村", -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "text-start" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "町域", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "text-start" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "二次医療圏", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "row justify-content-center mt-4 mb-4" }
const _hoisted_52 = { class: "d-flex align-items-center col-auto" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2 mb-0" }, "期間", -1))
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-auto text-center mb-0" }, "「病床機能報告」報告の有無", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "直近の人数複写", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "（単位：円）", -1))
const _hoisted_63 = {
  id: "shokushu-table",
  class: "mt-2"
}
const _hoisted_64 = { class: "table table-bordered" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"1%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"14%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"5%"} })
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      rowspan: "5"
    }, "職種"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "6",
      style: {"padding":"1em 0"},
      class: "border-strong"
    }, "常勤と非常勤を区別できる場合"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "4",
      style: {"padding":"1em 0"}
    }, "常勤と非常勤を区別できない場合")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "常勤職員"),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      class: "border-strong"
    }, "非常勤職員"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "給与総額"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "4" }, [
      /*#__PURE__*/_createTextVNode("人数"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("（人）")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "給与総額"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "3" }, [
      /*#__PURE__*/_createTextVNode("人数"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("（人）")
    ]),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "3" }, "給与総額"),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "3",
      class: "border-strong"
    }, [
      /*#__PURE__*/_createTextVNode("人数"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("（人）")
    ]),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "給料と賞与を区分できる場合"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "3" }, [
      /*#__PURE__*/_createTextVNode("給料と賞与を"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("区分できない場合")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "給料と賞与を区分できる場合"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, [
      /*#__PURE__*/_createTextVNode("給料と賞与を"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("区分できない場合")
    ]),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "給料"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "賞与")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "給料"),
    /*#__PURE__*/_createElementVNode("th", null, "賞与")
  ])
], -1))
const _hoisted_67 = { class: "text-center" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "医師", -1))
const _hoisted_69 = { class: "text-center" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "歯科医師", -1))
const _hoisted_71 = { class: "text-center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "薬剤師", -1))
const _hoisted_73 = { class: "text-center" }
const _hoisted_74 = { class: "text-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "保健師", -1))
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "助産師", -1))
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "看護師", -1))
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "准看護師", -1))
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = { class: "text-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "診療放射線技師", -1))
const _hoisted_85 = { class: "text-center" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "臨床工学技士", -1))
const _hoisted_87 = { class: "text-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "臨床検査技師", -1))
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = { class: "indent-1" }
const _hoisted_91 = { class: "text-center" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "理学療法士", -1))
const _hoisted_93 = { class: "text-center" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "作業療法士", -1))
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "視能訓練士", -1))
const _hoisted_97 = { class: "text-center" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "言語聴覚士", -1))
const _hoisted_99 = { class: "text-center" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "歯科衛生士", -1))
const _hoisted_101 = { class: "text-center" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "歯科技工士", -1))
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = { class: "indent-1" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "管理栄養士", -1))
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "栄養士", -1))
const _hoisted_109 = { class: "text-center" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "調理師", -1))
const _hoisted_111 = { class: "text-center" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "社会福祉士", -1))
const _hoisted_113 = { class: "text-center" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "精神保健福祉士", -1))
const _hoisted_115 = { class: "text-center" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "保育士", -1))
const _hoisted_117 = { class: "text-center" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "看護補助者", -1))
const _hoisted_119 = { class: "text-center" }
const _hoisted_120 = { class: "indent-1" }
const _hoisted_121 = { class: "text-center" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事務担当職員", -1))
const _hoisted_123 = { class: "text-center" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "医師事務作業補助者", -1))
const _hoisted_125 = { class: "text-center" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "診療情報管理士", -1))
const _hoisted_127 = { class: "text-center" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "その他の職員", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_input_kin = _resolveComponent("input-kin")!
  const _component_tooltip_icon = _resolveComponent("tooltip-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_loading_button, {
        color: "primary",
        onClick: _ctx.onClickedRegister,
        class: "mr-2"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_loading_button, {
        color: "primary",
        onClick: _ctx.onClickedRecalculate,
        class: "mr-5"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("p", _hoisted_5, "職種別給与総額及びその人数に関する情報（" + _toDisplayString(_ctx.clinicOrHospitalLabel) + "）", 1),
    _createElementVNode("table", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"100%","resize":"none"},
              value: _ctx.corporationInfo?.medicalCorporationNumber,
              disabled: ""
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"100%","resize":"none"},
              value: _ctx.corporationInfo?.corporationNumber,
              disabled: ""
            }, null, 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_12,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"25%","resize":"none"},
              value: _ctx.facilityInfo?.hasBedOutpatientMgmtNumber,
              disabled: ""
            }, null, 8, _hoisted_13),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start ml-2 ml-auto",
              style: {"width":"75%","resize":"none"},
              value: _ctx.facilityInfo?.bedOutpatientMgmtNumber,
              disabled: ""
            }, null, 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_15,
          _createElementVNode("td", null, [
            _createElementVNode("textarea", {
              class: "form-control-sm text-start",
              style: {"width":"25%","resize":"none"},
              value: _ctx.facilityInfo?.hasMedicalInstitutionCode,
              disabled: ""
            }, null, 8, _hoisted_16),
            _createElementVNode("textarea", {
              class: "form-control-sm text-start ml-2 ml-auto",
              style: {"width":"75%","resize":"none"},
              value: _ctx.facilityInfo?.medicalInstitutionCode,
              disabled: ""
            }, null, 8, _hoisted_17)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("td", _hoisted_21, [
              _createElementVNode("textarea", {
                class: "form-control-sm text-start",
                style: {"width":"100%","resize":"none"},
                value: _ctx.corporationInfo?.corporateName,
                disabled: ""
              }, null, 8, _hoisted_22)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.clinicOrHospitalLabel) + "名", 1),
            _createElementVNode("td", _hoisted_24, [
              _createElementVNode("textarea", {
                class: "form-control-sm text-start",
                style: {"width":"100%","resize":"none"},
                value: _ctx.facilityInfo?.hospitalClinicName,
                disabled: ""
              }, null, 8, _hoisted_25)
            ]),
            _createElementVNode("td", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.executiveCount,
                  disabled: ""
                }, null, 8, _hoisted_29)
              ])
            ]),
            _createElementVNode("td", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.staffCount,
                  disabled: ""
                }, null, 8, _hoisted_33)
              ])
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.clinicOrHospitalLabel) + "所在地", 1),
            _createElementVNode("td", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.prefecture,
                  disabled: ""
                }, null, 8, _hoisted_38)
              ])
            ]),
            _createElementVNode("td", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.municipality,
                  disabled: ""
                }, null, 8, _hoisted_42)
              ])
            ]),
            _createElementVNode("td", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.townArea,
                  disabled: ""
                }, null, 8, _hoisted_46)
              ])
            ]),
            _createElementVNode("td", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("textarea", {
                  class: "form-control-sm text-start",
                  style: {"width":"100%","resize":"none"},
                  value: _ctx.facilityInfo?.secondaryMedicalArea,
                  disabled: ""
                }, null, 8, _hoisted_50)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _createElementVNode("textarea", {
          class: "form-control-sm text-center",
          style: {"width":"200px","resize":"none"},
          value: _ctx.startDate + ' ～ ' + _ctx.endDate,
          disabled: ""
        }, null, 8, _hoisted_54)
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("textarea", {
          class: "form-control-sm text-start",
          style: {"width":"200px","resize":"none"},
          value: _ctx.facilityInfo?.hasBedFunctionReport,
          disabled: ""
        }, null, 8, _hoisted_58)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickedCopy,
          class: "mr-4"
        }, {
          default: _withCtx(() => [
            _hoisted_60,
            _hoisted_61
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_62
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("table", _hoisted_64, [
        _hoisted_65,
        _hoisted_66,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_67, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkboxStates.Doctor.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Doctor.isChecked]
              ])
            ]),
            _hoisted_68,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctorItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Doctor.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_69, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkboxStates.Dentist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Dentist.isChecked]
              ])
            ]),
            _hoisted_70,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dentistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Dentist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_71, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkboxStates.Pharmacist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Pharmacist.isChecked]
              ])
            ]),
            _hoisted_72,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pharmacistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Pharmacist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_73, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkboxStates.NursingStaff.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NursingStaff.isChecked]
              ])
            ]),
            _createElementVNode("td", null, [
              _createTextVNode("看護職員"),
              _createVNode(_component_tooltip_icon, { text: '保健師、助産師、看護師、准看護師に区分できない場合、看護職員のみに入力してください' })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursingStaffItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.NursingStaff.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_74, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkboxStates.PublicHealthNurse.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.PublicHealthNurse.isChecked]
              ])
            ]),
            _hoisted_75,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicHealthNurseItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.PublicHealthNurse.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_76, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkboxStates.Midwife.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Midwife.isChecked]
              ])
            ]),
            _hoisted_77,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.midwifeItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Midwife.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_78, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkboxStates.Nurse.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Nurse.isChecked]
              ])
            ]),
            _hoisted_79,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nurseItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Nurse.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_80, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkboxStates.AssistantNurse.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.AssistantNurse.isChecked]
              ])
            ]),
            _hoisted_81,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assistantNurseItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.AssistantNurse.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_82, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkboxStates.OtherMedicalTechnicians.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.OtherMedicalTechnicians.isChecked]
              ])
            ]),
            _createElementVNode("td", null, [
              _createTextVNode("その他の医療技術者等"),
              _createVNode(_component_tooltip_icon, { text: '以降全ての職種に区分できない場合、その他の医療技術者等のみに入力してください' })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherMedicalTechniciansItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.OtherMedicalTechnicians.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_83, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkboxStates.RadiologicalTechnologist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.RadiologicalTechnologist.isChecked]
              ])
            ]),
            _hoisted_84,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radiologicalTechnologistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.RadiologicalTechnologist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_85, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkboxStates.ClinicalEngineer.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.ClinicalEngineer.isChecked]
              ])
            ]),
            _hoisted_86,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clinicalEngineerItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.ClinicalEngineer.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_87, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.checkboxStates.MedicalLaboratoryTechnologist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.MedicalLaboratoryTechnologist.isChecked]
              ])
            ]),
            _hoisted_88,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicalLaboratoryTechnologistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.MedicalLaboratoryTechnologist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_89, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.checkboxStates.RehabilitationStaff.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.RehabilitationStaff.isChecked]
              ])
            ]),
            _createElementVNode("td", _hoisted_90, [
              _createTextVNode("リハビリスタッフ"),
              _createVNode(_component_tooltip_icon, { text: '理学療法士、作業療法士、視能訓練士、言語聴覚士に区分できない場合、リハビリスタッフのみに入力してください' })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rehabilitationStaffItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.RehabilitationStaff.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_91, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkboxStates.PhysicalTherapist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.PhysicalTherapist.isChecked]
              ])
            ]),
            _hoisted_92,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.physicalTherapistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.PhysicalTherapist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_93, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.checkboxStates.OccupationalTherapist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.OccupationalTherapist.isChecked]
              ])
            ]),
            _hoisted_94,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.occupationalTherapistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.OccupationalTherapist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_95, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.checkboxStates.Orthoptist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Orthoptist.isChecked]
              ])
            ]),
            _hoisted_96,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orthoptistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Orthoptist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_97, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.checkboxStates.SpeechTherapist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.SpeechTherapist.isChecked]
              ])
            ]),
            _hoisted_98,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speechTherapistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.SpeechTherapist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_99, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.checkboxStates.DentalHygienist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.DentalHygienist.isChecked]
              ])
            ]),
            _hoisted_100,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dentalHygienistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.DentalHygienist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_101, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.checkboxStates.DentalTechnician.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.DentalTechnician.isChecked]
              ])
            ]),
            _hoisted_102,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dentalTechnicianItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.DentalTechnician.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_103, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.checkboxStates.NutritionistEtc.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NutritionistEtc.isChecked]
              ])
            ]),
            _createElementVNode("td", _hoisted_104, [
              _createTextVNode("栄養士等"),
              _createVNode(_component_tooltip_icon, { text: '管理栄養士、栄養士、調理師に区分できない場合、栄養士等のみに入力してください' })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nutritionistEtcItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.NutritionistEtc.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_105, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.checkboxStates.Dietitian.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Dietitian.isChecked]
              ])
            ]),
            _hoisted_106,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dietitianItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Dietitian.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_107, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.checkboxStates.Nutritionist.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Nutritionist.isChecked]
              ])
            ]),
            _hoisted_108,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nutritionistItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Nutritionist.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_109, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.checkboxStates.Cook.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.Cook.isChecked]
              ])
            ]),
            _hoisted_110,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cookItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.Cook.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_111, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.checkboxStates.SocialWorker.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.SocialWorker.isChecked]
              ])
            ]),
            _hoisted_112,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialWorkerItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.SocialWorker.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_113, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.checkboxStates.PsychiatricSocialWorker.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.PsychiatricSocialWorker.isChecked]
              ])
            ]),
            _hoisted_114,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.psychiatricSocialWorkerItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.PsychiatricSocialWorker.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_115, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.checkboxStates.NurseryTeacher.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NurseryTeacher.isChecked]
              ])
            ]),
            _hoisted_116,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nurseryTeacherItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.NurseryTeacher.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_117, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.checkboxStates.NursingAssistant.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.NursingAssistant.isChecked]
              ])
            ]),
            _hoisted_118,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nursingAssistantItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.NursingAssistant.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_119, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.checkboxStates.OfficeStaff.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.OfficeStaff.isChecked]
              ])
            ]),
            _createElementVNode("td", _hoisted_120, [
              _createTextVNode("事務職員"),
              _createVNode(_component_tooltip_icon, { text: '事務担当職員、医師事務作業補助者、診療情報管理士に区分できない場合、事務職員のみに入力してください' })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.officeStaffItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.OfficeStaff.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_121, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.checkboxStates.AdministrativeStaff.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.AdministrativeStaff.isChecked]
              ])
            ]),
            _hoisted_122,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.administrativeStaffItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.AdministrativeStaff.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_123, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.checkboxStates.MedicalClerk.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.MedicalClerk.isChecked]
              ])
            ]),
            _hoisted_124,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicalClerkItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.MedicalClerk.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_125, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.checkboxStates.MedicalInformationManager.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.MedicalInformationManager.isChecked]
              ])
            ]),
            _hoisted_126,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medicalInformationManagerItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.MedicalInformationManager.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_127, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.checkboxStates.OtherStaff.isChecked) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.checkboxStates.OtherStaff.isChecked]
              ])
            ]),
            _hoisted_128,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherStaffItems, (item) => {
              return (_openBlock(), _createElementBlock("td", {
                key: item.kmkType
              }, [
                _createVNode(_component_input_kin, {
                  modelValue: item.kin,
                  "onUpdate:modelValue": ($event: any) => ((item.kin) = $event),
                  min: 0,
                  "allow-blank": true,
                  disabled: _ctx.checkboxStates.OtherStaff.isDisabled
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}